import React from 'react';
import { Search } from 'lucide-react';

/** Campo de busca canônico (ícone + input). Substitui as ~43 reimplementações. */
export default function SearchInput({ value, onChange, placeholder = 'Buscar...', className = '', ...props }) {
  return (
    <div className={`relative ${className}`}>
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 w-4 h-4 pointer-events-none" />
      <input
        type="text"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        aria-label={placeholder}
        className="w-full pl-9 pr-3 py-2 text-sm border border-slate-300 rounded-lg focus:border-primary"
        {...props}
      />
    </div>
  );
}
